import {
  APPLY_DRAFT,
  DELETE_REPORT,
  RENAME_REPORT,
  SAVE_AS_NEW,
  TOGGLE_BOOKMARK,
  REVERT_DRAFT,
  CREATE_REPORT_GROUP,
  RENAME_REPORT_GROUP,
  GROUP_REPORTS,
  UNGROUP_REPORTS,
  DELETE_REPORT_GROUP,
  ADD_DASHBOARD_PIN,
  REMOVE_DASHBOARD_PIN,
  UPDATE_DASHBOARD_PIN,
} from "../constants/reportActions";

export const REPORT_MESSAGES: Record<string, string> = {
  [SAVE_AS_NEW]: "Report saved as new",
  [DELETE_REPORT]: "Report deleted",
  [APPLY_DRAFT]: "Draft applied",
  [REVERT_DRAFT]: "Draft reverted",
  [TOGGLE_BOOKMARK]: "Status updated",
  [RENAME_REPORT]: "Report renamed",
};

export const GROUP_MESSAGES: Record<string, string> = {
  [CREATE_REPORT_GROUP]: "Group created",
  [RENAME_REPORT_GROUP]: "Group renamed",
  [GROUP_REPORTS]: "Reports grouped",
  [UNGROUP_REPORTS]: "Reports ungrouped",
  [DELETE_REPORT_GROUP]: "Group deleted",
};

export const PIN_MESSAGES: Record<string, string> = {
  [ADD_DASHBOARD_PIN]: "Pinned to dashboard",
  [REMOVE_DASHBOARD_PIN]: "Pin removed",
  [UPDATE_DASHBOARD_PIN]: "Pin updated",
};
